import { Button, message } from 'antd';
import React, { Component } from 'react';
import { AxiosGetSecretApi } from '../../../../../utils/fetchApi';
import { connect } from 'react-redux';
import StaticClass from '../../../../../utils/staticClass';
import { LocalStore } from '../../../../../utils/LocalStore/index';

class SearchResult5000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isRender: false,
    };

    this.listDuAnTitle = [
      'Mã phân khu',
      'Tên dự án',
      'Mã quy hoạch chung',
      'Diện tích (ha)',
      'Số quyết định pháp lý',
      'Năm ra quyết định pháp lý',
      'Cơ quan phê duyệt dự án',
      'Vị trí',
      'Năm quy hoạch',
      'Tình trạng',
    ];

    this.listDuAnValue = [
      'MaPhanKhu',
      'TenPhanKhu',
      'MaQHChung',
      'DienTich',
      'QuyetDinhPhapLy',
      'NamRaQDPL',
      'CoQuanpheDuyet',
      'ViTri',
      'NamQH',
      'TinhTrang',
    ];

    this.listTienDo = [
      {
        value: 0,
        name: '-',
      },
      {
        value: 1,
        name: 'Cơ bản hoàn thành',
      },

      {
        value: 2,
        name: 'Đang triển khai',
      },

      {
        value: 3,
        name: 'Chưa triển khai',
      },

      {
        value: 4,
        name: 'Chậm triển khai',
      },
    ];
  }

  componentDidMount() {
    this.getDataPhanKhu();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.getDataPhanKhu();
      this.props.hidePoint();
      this.setState({
        isShowLocation: false,
      });
    }
  }

  async getDataPhanKhu() {
    if (this.props.data) {
      let id = undefined;
      console.log(this.props.data);

      if (this.props.isEnableLayer.includes('QHPK_Polygon')) {
        id = this.props.data.MaPhanKhu;
      } else {
        if (
          this.props.isEnableLayer.includes('QHPK_RanhGioi') ||
          this.props.isEnableLayer.includes('QHPK_Line')
        ) {
          id = this.props.data.OBJECTID;
        }
      }

      if (id) {
        let res = await AxiosGetSecretApi(
          `/api/qh-phan-khu/search?curPage=1&pageSize=10&OBJECTID=${id}`
        );
        if (
          res &&
          res.dataResult &&
          Array.isArray(res.dataResult) &&
          res.dataResult.length > 0
        ) {
          let convertData = undefined;
          if (res.dataResult[0] && res.dataResult[0].TinhTrang) {
            convertData = {
              ...res.dataResult[0],
              TinhTrang: this.listTienDo[res.dataResult[0].TinhTrang].name,
            };
          } else {
            convertData = this.props.data;
          }
          this.getGeoData(res.dataResult[0].OBJECTID);
          this.setState({
            data: convertData,
            isRender: true,
          });
        }
        return;
      }
    }
    this.setState({
      isRender: false,
    });
    message.error('Chưa có thông tin (Dữ liệu đang cập nhật)');
  }

  async getGeoData(id) {
    let res = await AxiosGetSecretApi(
      `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/8/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`
    );
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    )
      this.props.drawRing(res.features[0].geometry.rings);
    // console.log(res.features[0].geometry.rings)
  }

  showLocation() {
    if (this.state.isShowLocation) {
      this.props.hidePoint(this.state.data);
    } else {
      this.props.showPoint(this.state.data);
      setTimeout(() => {
        document
          .getElementById('listlocation')
          .scrollIntoView({ behavior: 'smooth' });
      }, 50);
    }
    this.setState({
      isShowLocation: !this.state.isShowLocation,
    });
  }

  render() {
    return (
      <>
        {this.state.isRender && (
          <div className='search-result-lop-du-lieu'>
            <div className='search-500-header'>
              Thông tin dự án quy hoạch phân khu 1/5000
              <i
                className='fas fa-times icon-close'
                onClick={this.props.close}
              ></i>
            </div>

            <div className='search-500-body'>
              {this.listDuAnTitle.map((e, i) => (
                <div style={{ display: 'flex' }} key={i}>
                  <div
                    className='col-left search-500-text'
                    style={{ marginRight: 0, width: 145 }}
                  >
                    {e}:
                  </div>

                  <div
                    className='col-right search-500-text-gray'
                    style={{ maxWidth: 185 }}
                  >
                    {i === 5
                      ? this.state.data[`${this.listDuAnValue[i]}`]
                        ? new Date(
                            this.state.data[`${this.listDuAnValue[i]}`]
                          ).getFullYear()
                        : '-'
                      : this.state.data[`${this.listDuAnValue[i]}`]
                      ? i === 3
                        ? StaticClass.formatPrice(
                            `${this.state.data[`${this.listDuAnValue[i]}`]}`
                          )
                        : `${this.state.data[`${this.listDuAnValue[i]}`]}`
                      : '-'}
                  </div>
                </div>
              ))}

              {localStorage.loginSession && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '10px',
                  }}
                >
                  <Button
                    type='primary'
                    className='search-result-button'
                    onClick={() => this.showLocation()}
                  >
                    {this.state.isShowLocation ? 'Ẩn toạ độ' : 'Hiện toạ độ'}
                  </Button>
                </div>
              )}
              {this.state.isShowLocation ? (
                <div
                  style={{
                    textAlign: 'center',
                    maxHeight: '300px',
                    overflow: 'auto',
                    marginBottom: '10px',
                    marginTop: '10px',
                    padding: '0 10px 10px 10px',
                  }}
                >
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <th
                          style={{
                            border: '1px solid #a3a3a3',
                            width: '80px',
                          }}
                        >
                          Số hiệu góc thửa
                        </th>
                        <th style={{ border: '1px solid #a3a3a3' }}>X(m)</th>
                        <th style={{ border: '1px solid #a3a3a3' }}>Y(m)</th>
                      </tr>
                      {this.state.data &&
                        this.state.data.SHAPE &&
                        this.state.data.SHAPE.length === undefined &&
                        this.state.data.SHAPE.points.map((o, index, arr) => {
                          if (index < this.state.data.SHAPE.points.length - 1)
                            return (
                              <tr key={index}>
                                <td style={{ border: '1px solid #a3a3a3' }}>
                                  {index + 1}
                                </td>
                                <td style={{ border: '1px solid #a3a3a3' }}>
                                  {StaticClass.formatNumberFloat(o.x)}
                                </td>
                                <td style={{ border: '1px solid #a3a3a3' }}>
                                  {StaticClass.formatNumberFloat(o.y)}
                                </td>
                              </tr>
                            );
                        })}
                      {this.state.data &&
                        this.state.data.SHAPE &&
                        this.state.data.SHAPE.length &&
                        this.state.data.SHAPE.map((e, index1) => {
                          return (
                            <>
                              {e.points.map((p, index, arr) => {
                                return (
                                  <tr key={index}>
                                    <td style={{ border: '1px solid #a3a3a3' }}>
                                      {index === arr.length - 1 ? 1 : index + 1}
                                    </td>
                                    <td style={{ border: '1px solid #a3a3a3' }}>
                                      {StaticClass.formatNumberFloat(p.y)}
                                    </td>
                                    <td style={{ border: '1px solid #a3a3a3' }}>
                                      {StaticClass.formatNumberFloat(p.x)}
                                    </td>
                                  </tr>
                                );
                              })}
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              ) : null}
              <div id='listlocation'> </div>

              {/* {this.props.file && (
            <div style={{ display: "flex" }}>
              <div className="col-left search-500-text">File đính kèm:</div>
              <div>
                {this.props.file.map((e, i) => (
                  <div
                    className="col-right search-500-text"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "125px",
                    }}
                  >
                    <a href={e.Duongdanfiledinhkem}>{e.Tenfiledinhkem}</a>
                  </div>
                ))}
              </div>
            </div>
          )} */}
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEnableLayer: state.map.isEnableLayer,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult5000);
